import { useSyncExternalStore } from "react";

const KEY = "rc_favs";
const listeners = new Set();

const read = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

let snapshot = read();

const emit = () => listeners.forEach((l) => l());

const subscribe = (fn) => {
  listeners.add(fn);
  const onStorage = (e) => {
    if (e.key === KEY) { snapshot = read(); fn(); }
  };
  window.addEventListener("storage", onStorage);
  return () => { listeners.delete(fn); window.removeEventListener("storage", onStorage); };
};

export const toggleFavorite = (id) => {
  snapshot = snapshot.includes(id) ? snapshot.filter((x) => x !== id) : [...snapshot, id];
  localStorage.setItem(KEY, JSON.stringify(snapshot));
  emit();
  return snapshot.includes(id);
};

export const useFavorites = () => useSyncExternalStore(subscribe, () => snapshot);
